import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { defaultSeleniumSeo, seleniumSeoByPath } from '../data/seoConfig';
import { publicPath, setPageSeo } from '../utils/seo';

function PageSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = seleniumSeoByPath[pathname] || defaultSeleniumSeo;
    setPageSeo({ ...seo, path: publicPath(pathname) });
  }, [pathname]);

  return null;
}

export default PageSeo;
